// Table centrale des libellés FR/EN
export const translations = {
  en: {
    reminders: "Reminders",
    email: "Email",
    password: "Password",
    login: "Log in",
    signup: "Sign up",
    alreadyHaveAccount: "Already have an account? Log in",
    noAccountYet: "No account yet? Sign up",

    all: "All",
    today: "Today",
    archive: "Archive",
    filters: "Filters",
    reset: "Reset",
    priority: "Priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    status: "Status",
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    dueDate: "Due Date",
    clearDate: "Clear date",
    lists: "Lists",
    noListsYet: "No lists yet",
    addNewList: "Add a new List",

    noTasksYet: "No tasks yet. Click \"Task\" to add one.",
    edit: "Edit",
    delete: "Delete",
    undo: "Undo",
    deleteAll: "Delete All",

    newTask: "New Task",
    editTask: "Edit Task",
    viewTask: "Task Details",
    title: "Title",
    taskPlaceholder: "What needs to be done?",
    description: "Description",
    descriptionPlaceholder: "Add some details... (optional)",
    date: "Date",
    list: "List",
    noList: "No list",
    cancel: "Cancel",
    close: "Close",
    create: "Create",
    save: "Save",

    newList: "New List",
    editList: "Edit List",
    listName: "List Name",
    enterListName: "Enter list name",
    color: "Color",

    deleteTask: "Delete Task",
    deleteTaskConfirm: "Are you sure you want to delete",
    thisActionCannotBeUndone: "This action cannot be undone.",
    
    deleteList: "Delete List",
    deleteListConfirm: "Are you sure you want to delete the list",
    tasksWillBeKept: "Tasks in this list will be kept but unassigned.",

    deleteAllArchived: "Delete All Archived Tasks",
    deleteAllArchivedConfirm: "Are you sure you want to delete all",
    archivedTasks: "archived tasks",

    account: "Account",
    logOut: "Log out",
  },

  fr: {
    reminders: "Rappels",
    email: "E-mail",
    password: "Mot de passe",
    login: "Se connecter",
    signup: "S'inscrire",
    alreadyHaveAccount: "Déjà un compte ? Se connecter",
    noAccountYet: "Pas encore de compte ? S'inscrire",

    all: "Tout",
    today: "Aujourd'hui",
    archive: "Archives",
    filters: "Filtres",
    reset: "Réinit.",
    priority: "Priorité",
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    status: "Statut",
    pending: "En attente",
    inProgress: "En cours",
    completed: "Terminé",
    dueDate: "Échéance",
    clearDate: "Effacer la date",
    lists: "Listes",
    noListsYet: "Aucune liste",
    addNewList: "Ajouter une liste",

    noTasksYet: "Aucune tâche. Cliquez sur \"Task\" pour en créer une.",
    edit: "Modifier",
    delete: "Supprimer",
    undo: "Annuler",
    deleteAll: "Tout supprimer",

    newTask: "Nouvelle tâche",
    editTask: "Modifier la tâche",
    viewTask: "Détails de la tâche",
    title: "Titre",
    taskPlaceholder: "Que devez-vous faire ?",
    description: "Description",
    descriptionPlaceholder: "Ajouter des détails... (optionnel)",
    date: "Date",
    list: "Liste",
    noList: "Aucune liste",
    cancel: "Annuler",
    close: "Fermer",
    create: "Créer",
    save: "Enregistrer",

    newList: "Nouvelle liste",
    editList: "Modifier la liste",
    listName: "Nom de la liste",
    enterListName: "Entrez le nom de la liste",
    color: "Couleur",

    deleteTask: "Supprimer la tâche",
    deleteTaskConfirm: "Êtes-vous sûr de vouloir supprimer",
    thisActionCannotBeUndone: "Cette action est irréversible.",
    
    deleteList: "Supprimer la liste",
    deleteListConfirm: "Êtes-vous sûr de vouloir supprimer la liste",
    tasksWillBeKept: "Les tâches de cette liste seront conservées mais non assignées.",

    deleteAllArchived: "Supprimer toutes les tâches archivées",
    deleteAllArchivedConfirm: "Êtes-vous sûr de vouloir supprimer les",
    archivedTasks: "tâches archivées",

    account: "Compte",
    logOut: "Déconnexion",
  },
};

// Renvoie la traduction demandée, retombe sur l'anglais si manquante
export function getTranslation(lang, key) {
  return translations[lang]?.[key] || translations.en[key] || key;
}
